module.exports = "https://cdn.hellotech.com/client-assets/home-office-setup-desktop_5ff7d69cc85293f32b5435e8a1f15053.jpg";